'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React, { useState } from 'react';
import { formatClassName, getPageName, isInCurrentDirectory } from '@/utils/helpers';
interface NavItem {
  readonly label: string;
  readonly href: string;
  readonly side: 'left' | 'right';
  readonly children?: readonly NavItem[];
}
interface NavItemProps {
  readonly item: NavItem;
  readonly side: 'left' | 'right';
}
export const NavItemComponent: React.FC<NavItemProps> = t0 => {
  const $ = _c(18);
  const {
    item,
    side
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname() || "";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleMouseEnter = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleMouseLeave = t2;
  const isInDirectory = isInCurrentDirectory(pathname, item.href);
  const ulClassName = item.children && item.children.length >= 3 ? "top-app-bav-dropdown-nav decorate-with-border" : "top-app-bav-dropdown-nav";
  let t3;
  if ($[2] !== item.label) {
    t3 = formatClassName(getPageName(item.label));
    $[2] = item.label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = getPageName(pathname) === getPageName(item.href) ? "page" : undefined;
  const t5 = isInDirectory ? "true" : "false";
  let t6;
  if ($[4] !== item.href || $[5] !== item.label || $[6] !== t4 || $[7] !== t5) {
    t6 = <Link aria-current={t4} data-is-in-current-directory={t5} href={item.href}>{item.label}</Link>;
    $[4] = item.href;
    $[5] = item.label;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isOpen || $[10] !== item.children || $[11] !== side || $[12] !== ulClassName) {
    t7 = item.children && <ul className={ulClassName} data-is-open={isOpen ? "true" : "false"}>{item.children.filter(child => child.side === side).map(child_0 => <NavItemComponent item={child_0} key={child_0.href} side={side} />)}</ul>;
    $[9] = isOpen;
    $[10] = item.children;
    $[11] = side;
    $[12] = ulClassName;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t6 || $[16] !== t7) {
    t8 = <li className={t3} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>{t6}{t7}</li>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export type { NavItem, NavItemProps };